import React from 'react';

import { SvgReload } from '../atoms/svg/control/Reload';

import { Box } from '@chakra-ui/react';
import { SvgReloadEn } from '../atoms/svg/control/ReloadEn';
import { SvgOverview } from '../atoms/svg/control/Overview';
import { SvgOverviewEn } from '../atoms/svg/control/OverviewEn';
import { SvgHereEn } from '../atoms/svg/control/HereEn';
import { SvgHere } from '../atoms/svg/control/Here';
import { SvgDispAll } from '../atoms/svg/control/DispAll';
import { SvgDispAllEn } from '../atoms/svg/control/DispAllEn';
import { SvgOnlyLowFloorEn } from '../atoms/svg/control/OnlyLowFloorEn';
import { SvgOnlyLowFloor } from '../atoms/svg/control/OnlyLowFloor';
import { SvgLanguageSwitchEn } from '../atoms/svg/control/LanguageSwitchEn';
import { SvgLanguageSwitch } from '../atoms/svg/control/LanguageSwitch';
import { SvgHelp } from '../atoms/svg/control/Help';

const icons = {
  SvgReload,
  SvgOverview,
  SvgHere,
  SvgOnlyLowFloor,
  SvgDispAll,
  SvgLanguageSwitch,
  SvgHelp
};

type Name = keyof typeof icons;

type Props = {
  language?: string;
  name: Name;
  width?: string;
  height?: string;
  onClick?: () => void;
};

const getChild = (name: Name, language: string) => {
  switch (name) {
    case 'SvgReload':
      return language === 'en' ? (
        <SvgReloadEn></SvgReloadEn>
      ) : (
        <SvgReload></SvgReload>
      );

    case 'SvgOverview':
      return language === 'en' ? (
        <SvgOverviewEn></SvgOverviewEn>
      ) : (
        <SvgOverview></SvgOverview>
      );

    case 'SvgHere':
      return language === 'en' ? <SvgHereEn></SvgHereEn> : <SvgHere></SvgHere>;

    case 'SvgDispAll':
      return language === 'en' ? (
        <SvgDispAllEn></SvgDispAllEn>
      ) : (
        <SvgDispAll></SvgDispAll>
      );

    case 'SvgOnlyLowFloor':
      return language === 'en' ? (
        <SvgOnlyLowFloorEn></SvgOnlyLowFloorEn>
      ) : (
        <SvgOnlyLowFloor></SvgOnlyLowFloor>
      );

    case 'SvgLanguageSwitch':
      return language === 'en' ? (
        <SvgLanguageSwitchEn></SvgLanguageSwitchEn>
      ) : (
        <SvgLanguageSwitch></SvgLanguageSwitch>
      );

    case 'SvgHelp':
      return <SvgHelp></SvgHelp>;

    default:
      return null;
  }
};

const DEFAULT_SIZE = '100%';

const ControlButton: React.FC<Props> = (props) => {
  const {
    language = 'ja',
    name,
    width = DEFAULT_SIZE,
    height = DEFAULT_SIZE,
    onClick
  } = props;

  return (
    <Box width={width} height={height} onClick={onClick} cursor='pointer'>
      {getChild(name, language)}
    </Box>
  );
};

export default React.memo(ControlButton);
